import { renderToSheetList } from 'fela-dom';
export const getStyles = args => renderToSheetList(args);